<ng-container *ngIf="!isLoading">
    <wizard-availability-calendar
        [availabilityWindows]="availabilityWindows"
        [meetingLength]="meetingLength"
        (onSave)="handleSaveAvailabilityWindows($event)"
        [timezone]="timezone"
    ></wizard-availability-calendar>
</ng-container>
